/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function BatchCreateImportJobRowsRequestFromJSON(json) {
    return BatchCreateImportJobRowsRequestFromJSONTyped(json, false);
}
export function BatchCreateImportJobRowsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        rows: json['rows'],
    };
}
export function BatchCreateImportJobRowsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        rows: value.rows,
    };
}
